import React, {
  createContext,
  useCallback,
  useContext,
  useState,
} from "react";

export interface DocumentHeadMeta {
  title?: string | null;
  description?: string | null;
  ogTitle?: string | null;
  ogDescription?: string | null;
  ogImage?: string | null;
  ogType?: string | null;
}

interface DocumentHeadContextValue {
  meta: DocumentHeadMeta | null;
  setMeta: (meta: DocumentHeadMeta | null) => void;
}

const DocumentHeadContext = createContext<DocumentHeadContextValue | null>(null);

export function DocumentHeadProvider({ children }: { children: React.ReactNode }) {
  const [meta, setMetaState] = useState<DocumentHeadMeta | null>(null);
  const setMeta = useCallback((value: DocumentHeadMeta | null) => {
    setMetaState(value);
  }, []);
  return (
    <DocumentHeadContext.Provider value={{ meta, setMeta }}>
      {children}
    </DocumentHeadContext.Provider>
  );
}

export function useDocumentHead() {
  const ctx = useContext(DocumentHeadContext);
  return ctx ?? { meta: null, setMeta: () => {} };
}
